<template lang="pug">
  v-flex
    form#form-sign-up
      h1.omnesMedium Crear cuenta
      p.omnesRegular
        span
          | Hola {{ names }},
        |  no tienes una cuenta registrada
        br
        |  Empecemos, es muy fácil:
      p.omnesMedium
        | Elige una de estas opciones
        br
        |  para validar tu registro
      v-layout(v-if="options.length > 0" row wrap)
        v-flex(xs1 sm1 :md2="largeText" :lg2="largeText" :md3="normalText" :lg3="normalText")
        v-flex(xs10 sm10 :md8="largeText" :lg8="largeText" :md6="normalText" :lg6="normalText")
          .options(v-for="(option, index) in options" :key="option.value")
            img(:src="icons.email" alt="icons_email" v-if="option.value === 1")
            img(:src="icons.cellphone" alt="icons_cellphone" v-if="option.value === 2")
            p {{ option.text }}
            v-btn(outline flat fab small @click="sendRecoveryRequest(option.value, option.text)")
              v-icon arrow_forward
          router-link(target="_self" :to="{name: 'NotRememberPassword', params: { source: 'signup' }}" id="linkToForgotData")
            span Ya no tengo acceso a este
            br
            span  teléfono y/o correo
        v-flex(xs1 sm1 :md2="largeText" :lg2="largeText" :md3="normalText" :lg3="normalText")
      v-layout.loading-options(v-else row wrap)
        p Cargando opciones
        pulse-loader(:loading="true" :color="color" :size="size")
      //- LOADER PROCESS
      v-dialog(v-model="loader" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | Enviando código de verificación...
            v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  props: ['options', 'numeroDocumento', 'tipoDocumento'],
  data () {
    return {
      color: '#1745A8',
      size: '11px',
      largeText: false,
      normalText: true,
      loader: false,
      icons: {
        cellphone: require('./../assets/iconsv4/celular_icon.svg'),
        email: require('./../assets/iconsv4/correo_icon.svg')
      },
      show: true
    }
  },
  computed: {
    ...mapGetters('user', ['names'])
  },
  methods: {
    ...mapActions('user', ['signUpVersion2']),
    sendRecoveryRequest (optionSelected, optionTextSelected) {
      this.loader = true
      var sendHash = { tipoDocumento: this.tipoDocumento, numeroDocumento: this.numeroDocumento, medioEnvioCodigo: optionSelected }
      this.signUpVersion2(sendHash).then((res) => {
        this.loader = false
        if (res.data.codigoRespuesta === '01') {
          // SET INITIAL VALUES IF USER REFRESH PAGE
          this.$gtm.trackEvent({
            event: 'RE envio de codigo de verificacion correcto',
            category: 'Registro',
            action: 'REacceso',
            label: 'Envio de codigo de verificacion correcto'
          })
          var initialValues = { opt: optionSelected, numeroDocumento: this.numeroDocumento, tipoDocumento: this.tipoDocumento, medioEnvio: optionTextSelected }
          this.$store.commit('user/setInitialData', initialValues)
          // GO TO VERIFY TMP PASSWORD
          this.$router.push({ name: 'VerifyPassword' })
        } else {
          this.$gtm.trackEvent({
            event: 'RE envio de codigo de verificacion erroneo',
            category: 'Registro',
            action: 'REerror',
            label: 'Envio de codigo de verificacion incorrecto'
          })
          this.$swal({
            title: 'Atención',
            text: 'Tenemos un inconviente al enviarte tu código de verificación para el registro. Por favor, vuelve a intentarlo en unos minutos o comunícate con nuestro Servicio de Atención al Cliente.',
            type: 'error',
            confirmButtonText: 'Entendido'
          })
        }
      })
        .catch(() => {
          this.loader = false
          this.$swal({
            title: 'Atención',
            text: 'Tenemos un inconviente al enviarte tu código de verificación para el registro. Por favor, vuelve a intentarlo en unos minutos o comunícate con nuestro Servicio de Atención al Cliente.',
            type: 'error',
            confirmButtonText: 'Entendido'
          })
        })
    }
  },
  mounted () {
    if (this.options[0] && this.options[0].text.length > 30) {
      this.largeText = true
      this.normalText = false
    } else {
      this.largeText = false
      this.normalText = true
    }
  },
  components: {
    PulseLoader
  }
}
</script>

<style>
  #form-sign-up { text-align: center; }
  #form-sign-up p span {
    color: #0855C4;
    font-family: 'Omnes Medium';
  }
  .options:first-child {
    border-bottom: 1px solid #717285;
    margin-bottom: 9px;
    padding-bottom: 6px;
  }
  .options {
    clear: both;
    overflow: hidden;
  }
  .options p {
    float: left;
    margin-bottom: 0;
    margin-top: 7px;
    margin-left: 9px;
  }
  .options img {
    width: 15px;
    float: left;
  }
  .options:first-child img { margin-top: 12px; }
  .options:first-child + .options img { margin-top: 7px; }
  .options button.v-btn {
    float: right;
    border: 1.5px solid #0855C4;
    color: #0855C4;
    width: 25px;
    height: 25px;
    margin-right: 0;
  }
  #form-sign-up .layout.row.wrap { margin-top: 3em; }
  a#linkToForgotData {
    margin-top: 2em;
    display: block;
  }
  .loading-options {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loading-options p {
    margin-bottom: 9px;
    text-transform: uppercase;
    font-family: 'Omnes Medium';
  }
  /* Mobile ----------- */
  @media only screen and (max-width : 600px) {
    #form-sign-up h1 { font-size: 21px; }
    #form-sign-up .layout.row.wrap { margin-top: 1em; }
  }
  /* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {
  }
</style>



// WEBPACK FOOTER //
// src/components/FormSignup.vue